// Mock data for AI pro pedagogy courses

export const coursesMock = {
  ms: {
    id: 'ms',
    title: 'AI pro mateřské školy',
    subtitle: 'Umělá inteligence jako praktická pomůcka v MŠ',
    tagline: 'Témata, omalovánky, příběhy, individualizace a méně administrativy – srozumitelně a bez stresu',
    price: 3400,
    duration: '8 vyučovacích hodin (rozděleno na 2×4 vyučovací hodiny, tj. 2×3 hodiny čistého času)',
    minParticipantsPresence: 8,
    minParticipantsOnline: 1,
    format: 'online nebo prezenčně',
    color: 'emerald',
    icon: 'Sparkles',
    benefits: [
      'hotový tematický blok (týdenní nebo měsíční) pro vaši třídu',
      'sadu materiálů na míru: omalovánky, jednoduché pracovní listy, krátké příběhy a pohádky',
      'varianty aktivit pro různé děti (mladší/starší, klidnější/živější)',
      'praktické tipy pro individualizaci a inkluzi (včetně práce s IVP a doporučeními z PPP/SPC)',
      'ukázky, jak si výrazně zjednodušit dokumentaci a komunikaci s rodiči',
      'jistotu, jak AI používat tak, aby odpovědi dávaly smysl právě pro prostředí MŠ'
    ],
    targetAudience: [
      'učitelky a učitelé mateřských škol',
      'ředitelky a vedení MŠ',
      'pedagogové řešící individualizaci, inkluzi a podpůrná opatření'
    ],
    topics: [
      'AI v MŠ jednoduše a prakticky (bez technických detailů)',
      'Tvorba témat, projektů a činností pro děti',
      'Inkluze a individualizace v běžné třídě MŠ',
      'Materiály na míru: omalovánky, listy, příběhy',
      'AI jako zdroj každodenní inspirace',
      'Administrativa, dokumentace a komunikace bez zbytečného psaní'
    ],
    adminBenefits: [
      'přípravě a úpravě pedagogických podkladů',
      'zpracování záznamů, hodnocení a dokumentace',
      'přípravě podkladů k IVP a doporučením z PPP/SPC',
      'komunikaci s rodiči a vedením školy'
    ],
    opJakInfo: {
      areas: [
        'rozvoje digitálních kompetencí pedagogů',
        'podpory inkluzivního vzdělávání',
        'individualizace vzdělávacího procesu',
        'snižování administrativní zátěže škol'
      ],
      note: 'Tento kurz však není realizován formou dotace. Žádná spoluúčast, žádná žádost, žádné vykazování. Kurz je hrazen přímo mateřskou školou.'
    }
  },
  zs: {
    id: 'zs',
    title: 'AI pro pedagogy',
    subtitle: 'Příprava výuky, hodnocení, komunikace s rodiči i oblast školní prevence',
    tagline: 'Praktický kurz financovatelný z OP JAK II',
    price: 3400,
    duration: '8 vyučovacích hodin (rozděleno na 2×4 vyučovací hodiny, tj. 2×3 hodiny čistého času)',
    minParticipantsPresence: 8,
    minParticipantsOnline: 1,
    format: 'prezenčně nebo online',
    color: 'blue',
    icon: 'GraduationCap',
    benefits: [
      'využívat AI jako smysluplnou podporu výuky',
      'nastavit férové hodnocení v době generovaného obsahu',
      'dělat prevenci v realitě dnešních digitálních rizik',
      'uvolnit ruce od zbytečné administrativy'
    ],
    challenges: [
      'jak si pomocí AI zjednodušit přípravu výuky, aniž by se z ní stal autopilot',
      'jak zadávat úkoly, které rozvíjejí myšlení, a ne jen „opisování s AI"',
      'jak spravedlivě hodnotit práci, u které není vždy jasné, zda je tvůrcem AI nebo žák',
      'jak zvládat komunikaci s rodiči a nové typy problémů ve třídě',
      'jak současně nastavit prevenci a chránit děti v digitálním prostředí'
    ],
    risks: [
      'deepfake obrázky a videa',
      'kyberšikana posílená AI',
      'falešné identity a manipulace',
      'zneužívání osobních dat a fotografií dětí'
    ],
    adminBenefits: [
      'rychlejšímu zpracování a úpravám formálních podkladů k výuce',
      'administrativní přípravě zadání, hodnocení a slovní zpětné vazby',
      'formulaci e-mailů, zpráv a oficiální komunikace se zákonnými zástupci',
      'přípravě formálních podkladů k třídnickým a preventivním hodinám'
    ],
    methodikBenefits: [
      'přehled o nových rizicích spojených s AI',
      'konkrétní scénáře preventivních a třídnických hodin',
      'oporu při řešení deepfake, kyberšikany a manipulace',
      'podklady pro komunikaci s rodiči v citlivých situacích'
    ],
    stats: {
      trainedTeachers: 1500,
      text: 'proškolili jsme více než 1 500 pedagogů'
    }
  }
};

export const testimonialsMock = [
  {
    id: 1,
    name: 'Mgr. Jana Nováková',
    role: 'Ředitelka MŠ',
    school: 'MŠ Sluníčko, Praha',
    text: 'Kurz nám otevřel úplně nové možnosti. Příprava týdenních témat mi teď zabere polovinu času a děti mají pestřejší program.',
    avatar: 'JN'
  },
  {
    id: 2,
    name: 'Bc. Petra Svobodová',
    role: 'Učitelka 1. stupně',
    school: 'ZŠ Třebíč',
    text: 'Konečně vím, jak férově hodnotit práce žáků v době AI. A administrativu mám pod kontrolou.',
    avatar: 'PS'
  },
  {
    id: 3,
    name: 'Mgr. Martin Dvořák',
    role: 'Metodik prevence',
    school: 'ZŠ Brno-Líšeň',
    text: 'Deepfake a kyberšikana jsou reálné problémy. Díky kurzu mám nástroje, jak s nimi pracovat.',
    avatar: 'MD'
  }
];

export const faqMock = [
  {
    question: 'Je školení určeno pro jednotlivce nebo pro školy?',
    answer: 'Obě varianty jsou možné. Jednotliví pedagogové se mohou přihlásit na online termíny. Ředitelé škol mohou objednat školení pro své pedagogy přímo ve škole.'
  },
  {
    question: 'Kolik pedagogů musí být pro školení ve škole?',
    answer: 'Školení realizujeme od 8 pedagogů.'
  },
  {
    question: 'Je obsah školení jiný pro MŠ, ZŠ a SŠ?',
    answer: 'Ano. Obsah školení vždy přizpůsobujeme typu školy.'
  },
  {
    question: 'Musím mít technické znalosti?',
    answer: 'Ne. Kurz je vhodný jak pro úplné začátečníky, tak i pro pokročilé. Vždy se přizpůsobujeme úrovni účastníků a vše vysvětlujeme srozumitelně a prakticky.'
  },
  {
    question: 'Jak probíhá financování z OP JAK II?',
    answer: 'Kurz je financovatelný z OP JAK II (šablony) nebo z DVPP. Rádi vám pomůžeme s administrativou a poradíme s celým procesem.'
  },
  {
    question: 'Dostanu materiály po kurzu?',
    answer: 'Ano, všechny materiály vytvořené během kurzu jsou vaše. Navíc dostanete přístup k našim šablonám a návodům.'
  }
];

export const contactMock = {
  email: 'info@aipropedagogy.cz',
  phones: ['+420 732 199 307', '+420 739 921 359']
};
